import { render, staticRenderFns } from "./FieldsTable.vue?vue&type=template&id=e2b5a87c&scoped=true&lang=pug"
import script from "./FieldsTable.vue?vue&type=script&lang=js"
export * from "./FieldsTable.vue?vue&type=script&lang=js"
import style0 from "./FieldsTable.vue?vue&type=style&index=0&id=e2b5a87c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2b5a87c",
  null
  
)

export default component.exports